import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchBaseQueryWithTokenCheck } from '@shared/utils/api.utils';

import type { GetTokenLedgerPayload, GetTokenLedgerResponse, GetTokenStatsResponse } from './token-ledger.types';

export const tokenLedgerApiSlice = createApi({
  reducerPath: 'tokenLedgerApi',
  baseQuery: fetchBaseQueryWithTokenCheck,
  endpoints: (builder) => ({
    getTokenLedger: builder.query<GetTokenLedgerResponse, GetTokenLedgerPayload>({
      query: (params) => ({ url: '/api/tokenLedger/v1', params }),
    }),
    getTokenStats: builder.query<GetTokenStatsResponse, void>({
      query: () => ({ url: '/api/stats/v1/tokens' }),
    }),
  }),
});

export const { useLazyGetTokenLedgerQuery, useGetTokenStatsQuery } = tokenLedgerApiSlice;
